import { HTMLProps, ReactNode } from 'react';
import cx from 'classnames';

import { useRouter } from 'hooks';
import { ArrowLeftIcon } from 'components/Icon';

import styles from './Navbar.module.scss';

export type NavbarProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & {
  title?: string | ReactNode;
  left?: ReactNode;
  right?: ReactNode;
};

const Navbar = ({ className, title, left, right }: NavbarProps): JSX.Element => {
  const router = useRouter();

  const handleOnGoBack = () => {
    if (router.canGoBack) {
      router.goBack();
    } else {
      router.replace('/');
    }
  };

  const defaultLeft = (
    <button type="button" className={styles.back} onClick={handleOnGoBack}>
      <ArrowLeftIcon width={24} height={24} />
    </button>
  );

  const defaultRight = null;

  const renderTitle = () => title;
  const renderLeft = () => left || defaultLeft;
  const renderRight = () => right || defaultRight;

  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.left}>{renderLeft()}</div>
      <div className={styles.title}>{renderTitle()}</div>
      <div className={styles.right}>{renderRight()}</div>
    </div>
  );
};

export default Navbar;
